import { useToast } from '@hprofits/ui';
import type { WatchSource } from 'vue';

import type { ErrorController } from '@/modules/shared/composables';
import { useErrorController } from '@/modules/shared/composables';

import type { NotificationActions } from './types';

type UsePageControllerProps = Readonly<{
  clearErrorsOn?: WatchSource<unknown>;
}>;

export type UsePageControllerResult = Readonly<{
  errors: ErrorController;
  notifications: NotificationActions;
}>;

/**
 * Page coordinator. Aggregates error panel and notifications toast.
 *
 * `isPending` is now owned by each provider — computed locally from the
 * provider's specific pending sources and passed directly into the context.
 */
export const usePageController = (options?: UsePageControllerProps): UsePageControllerResult => {
  const toast = useToast();

  const errors = useErrorController({
    clearOn: options?.clearErrorsOn,
  });

  const notifications: NotificationActions = {
    showNotification: (message: string): void => {
      toast.success(message);
    },
  };

  return { errors, notifications };
};
